export const DEFAULT_THEME = "light";
export const DEFAULT_COLOR = "orange";

export const THEMES = {
  DARK: "dark",
  LIGHT: "light",
};

export const COLORS = {
  ORANGE: "orange",
  PURPLE: "purple",
};
